function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { ExternalLinkIcon } from "../Molecules/icons";
export function Footer() {
    var _outerRef1_current, _outerRef2_current;
    var intl = useIntl();
    var ref2 = React.useRef(null);
    var ref1 = React.useRef(null);
    var outerRef2 = React.useRef(null);
    var outerRef1 = React.useRef(null);
    var _React_useState = _sliced_to_array(React.useState(true), 2), isDivider = _React_useState[0], setIsDivider = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(true), 2), isOuterDivider = _React_useState1[0], setIsOuterDivider = _React_useState1[1];
    useEffect(function() {
        var _outerRef1_current, _outerRef2_current;
        var _outerRef1_current_offsetTop, _outerRef2_current_offsetTop;
        if (((_outerRef1_current_offsetTop = (_outerRef1_current = outerRef1.current) === null || _outerRef1_current === void 0 ? void 0 : _outerRef1_current.offsetTop) !== null && _outerRef1_current_offsetTop !== void 0 ? _outerRef1_current_offsetTop : 0) > ((_outerRef2_current_offsetTop = (_outerRef2_current = outerRef2.current) === null || _outerRef2_current === void 0 ? void 0 : _outerRef2_current.offsetTop) !== null && _outerRef2_current_offsetTop !== void 0 ? _outerRef2_current_offsetTop : 0)) {
            setIsOuterDivider(false);
        }
    }, [
        (_outerRef1_current = outerRef1.current) === null || _outerRef1_current === void 0 ? void 0 : _outerRef1_current.offsetTop,
        (_outerRef2_current = outerRef2.current) === null || _outerRef2_current === void 0 ? void 0 : _outerRef2_current.offsetTop
    ]);
    useEffect(function() {
        var _ref1_current, _ref2_current;
        var _ref1_current_offsetTop, _ref2_current_offsetTop;
        if (!isOuterDivider && ((_ref1_current_offsetTop = (_ref1_current = ref1.current) === null || _ref1_current === void 0 ? void 0 : _ref1_current.offsetTop) !== null && _ref1_current_offsetTop !== void 0 ? _ref1_current_offsetTop : 0) > ((_ref2_current_offsetTop = (_ref2_current = ref2.current) === null || _ref2_current === void 0 ? void 0 : _ref2_current.offsetTop) !== null && _ref2_current_offsetTop !== void 0 ? _ref2_current_offsetTop : 0)) {
            setIsDivider(false);
        }
    }, [
        isOuterDivider
    ]);
    var campaign = "".concat(intl.formatMessage({
        defaultMessage: "Campaign by",
        id: "xubukL"
    }), " ");
    return /*#__PURE__*/ React.createElement("footer", {
        className: "flex flex-auto w-full items-end justify-end"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full items-end pr-4 md:pr-8 pb-10"
    }, /*#__PURE__*/ React.createElement("nav", {
        className: "flex flex-row items-center justify-end flex-wrap ms-[20%] pt-4 gap-3",
        "aria-label": "Footer"
    }, /*#__PURE__*/ React.createElement("div", {
        ref: outerRef2,
        className: "inline-flex items-baseline"
    }, /*#__PURE__*/ React.createElement("p", {
        className: " text-white text-[14px] flex flex-row items-baseline justify-center whitespace-break-spaces",
        rel: "noreferrer"
    }, campaign), /*#__PURE__*/ React.createElement("a", {
        className: "group flex flex-row text-white text-[14px]  items-baseline justify-center",
        target: "_blank",
        href: intl.formatMessage({
            defaultMessage: "Heks link",
            id: "vvxjpm"
        }),
        rel: "noreferrer"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "relative me-2"
    }, intl.formatMessage({
        defaultMessage: "Heks link text",
        id: "aMEa3N"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "block w-0 group-hover:w-full group-active:w-full transition-all duration-200 ease-in-out h-[1px] bg-white"
    })), /*#__PURE__*/ React.createElement(ExternalLinkIcon, null)), isOuterDivider && /*#__PURE__*/ React.createElement("span", {
        className: "text-white text-[14px] ms-3 me-[3px]"
    }, "|")), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-row items-center justify-end gap-3 flex-wrap max-w-[90%]",
        ref: outerRef1
    }, /*#__PURE__*/ React.createElement("a", {
        className: "group flex gap-2 flex-row  text-white text-[14px] items-baseline justify-center relative",
        href: intl.formatMessage({
            defaultMessage: "Imprint link",
            id: "CCqzim"
        }),
        target: "_blank",
        rel: "noreferrer",
        ref: ref2
    }, /*#__PURE__*/ React.createElement("p", null, intl.formatMessage({
        defaultMessage: "Imprint",
        id: "xYJkOZ"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "block w-0 group-hover:w-full group-active:w-full transition-all duration-200 ease-in-out h-[1px] bg-white"
    })), /*#__PURE__*/ React.createElement(ExternalLinkIcon, null)), isDivider && /*#__PURE__*/ React.createElement("span", {
        className: "text-white text-[14px] me-[3px]"
    }, "|"), /*#__PURE__*/ React.createElement("a", {
        className: "group flex gap-2 flex-row text-white text-[14px]  items-baseline justify-center relative",
        href: intl.formatMessage({
            defaultMessage: "Privacy link",
            id: "UOugTE"
        }),
        target: "_blank",
        rel: "noreferrer",
        ref: ref1
    }, /*#__PURE__*/ React.createElement("p", null, intl.formatMessage({
        defaultMessage: "Privacy statement",
        id: "RVOcOM"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "block w-0 group-hover:w-full group-active:w-full transition-all duration-200 ease-in-out h-[1px] bg-white"
    })), /*#__PURE__*/ React.createElement(ExternalLinkIcon, null))))));
}
